import * as React from 'react';
import { PdsAlert as PdsAlertElement } from '@principal/design-system';
import { EventName } from '@lit/react';
import { PdsAlertProps } from '../../built-component-props';
import { createPdsReactComponent } from '../../create-pds-react-component';

export const PdsAlert = createPdsReactComponent<PdsAlertProps>()({
  tagName: 'pds-alert',
  elementClass: PdsAlertElement,
  react: React,
  events: {
    onClick: 'pds-button-click' as EventName<CustomEvent>,
  },
});
